(function (ng) {
    ng.module('evo.Packages.Filters').filter('numeralCurrency', function () {
        return function (price) {
            return numeral(price).format();
        };
    });
})(angular);